import { render, staticRenderFns } from "./EditTerms.page.vue?vue&type=template&id=4d39e48a&"
import script from "./EditTerms.page.vue?vue&type=script&lang=js&"
export * from "./EditTerms.page.vue?vue&type=script&lang=js&"
import style0 from "./EditTerms.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports